import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { name: "form" }
const _hoisted_4 = { class: "contain row" }
const _hoisted_5 = { class: "page-container card col-md-8" }
const _hoisted_6 = {
  key: 0,
  class: "row"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-fw pi-shield" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "2FA", -1)
const _hoisted_9 = {
  key: 1,
  class: "row"
}
const _hoisted_10 = { class: "col-md-12 p-4 pb-0" }
const _hoisted_11 = {
  key: 0,
  class: "row mb-3"
}
const _hoisted_12 = {
  key: 0,
  class: "mb-1"
}
const _hoisted_13 = { class: "p-tag" }
const _hoisted_14 = { class: "col-form-label-title" }
const _hoisted_15 = {
  key: 1,
  class: "col-md-6"
}
const _hoisted_16 = {
  key: 2,
  class: "col-md-6"
}
const _hoisted_17 = {
  key: 0,
  class: "row"
}
const _hoisted_18 = { class: "col-md-12 p-4 pt-0" }
const _hoisted_19 = { class: "row mb-3" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, null, -1)
const _hoisted_21 = { class: "d-flex col-md-6" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "p-1" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheHeader = _resolveComponent("TheHeader")!
  const _component_TheSidebar = _resolveComponent("TheSidebar")!
  const _component_ThePageHeader = _resolveComponent("ThePageHeader")!
  const _component_TheTabViewLoading = _resolveComponent("TheTabViewLoading")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_TabView = _resolveComponent("TabView")!
  const _component_Button = _resolveComponent("Button")!
  const _component_TheLoading = _resolveComponent("TheLoading")!
  const _component_ThePageError = _resolveComponent("ThePageError")!
  const _component_TheFooter = _resolveComponent("TheFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TheHeader),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_TheSidebar),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_ThePageHeader),
              (_ctx.pageError == '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(_component_TabView, { class: "p-1" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_TabPanel, null, {
                          header: _withCtx(() => [
                            _hoisted_7,
                            _hoisted_8
                          ]),
                          default: _withCtx(() => [
                            (_ctx.isPageLoading)
                              ? (_openBlock(), _createBlock(_component_TheTabViewLoading, { key: 0 }))
                              : _createCommentVNode("", true),
                            (!_ctx.isPageLoading)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                  _createElementVNode("div", _hoisted_10, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.settings, (setting, index) => {
                                      return (_openBlock(), _createElementBlock("div", { key: index }, [
                                        (!setting.isClosed && setting.propertyName.startsWith('1_'))
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                              (setting.propertyLabel.indexOf('|') != -1)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                                    _createVNode(_component_Divider, { align: "left" }, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("span", _hoisted_13, _toDisplayString(setting.propertyLabel.substring(0, setting.propertyLabel.indexOf('|'))), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]))
                                                : _createCommentVNode("", true),
                                              _createElementVNode("div", {
                                                class: _normalizeClass(["col-md-3", {'required' : (setting.propertyName.indexOf('_M_') != -1)}])
                                              }, [
                                                _createElementVNode("label", _hoisted_14, _toDisplayString(setting.propertyLabel.substring(setting.propertyLabel.indexOf('|') + 1)) + ":", 1),
                                                _createVNode(_component_InputText, {
                                                  class: "p-inputtext",
                                                  type: "hidden",
                                                  modelValue: setting.sequence,
                                                  "onUpdate:modelValue": ($event: any) => ((setting.sequence) = $event),
                                                  value: setting.sequence = index + 1
                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "value"])
                                              ], 2),
                                              (setting.propertyName.endsWith('_B'))
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                                    _createVNode(_component_InputSwitch, {
                                                      modelValue: setting.propertyValue,
                                                      "onUpdate:modelValue": ($event: any) => ((setting.propertyValue) = $event)
                                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                  ]))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                                    _createVNode(_component_InputText, {
                                                      class: "p-inputtext",
                                                      type: "text",
                                                      maxlength: "255",
                                                      placeholder: "Value",
                                                      modelValue: setting.propertyValue,
                                                      "onUpdate:modelValue": ($event: any) => ((setting.propertyValue) = $event)
                                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                  ]))
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]))
                                    }), 128))
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (!_ctx.isPageLoading)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                              _hoisted_20,
                              _createElementVNode("div", _hoisted_21, [
                                _hoisted_22,
                                _createVNode(_component_Button, {
                                  class: "p-button-sm",
                                  disabled: !_ctx.isValid,
                                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.update())),
                                  label: "Save"
                                }, null, 8, ["disabled"]),
                                (_ctx.isLoading)
                                  ? (_openBlock(), _createBlock(_component_TheLoading, { key: 0 }))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.pageError != '')
                ? (_openBlock(), _createBlock(_component_ThePageError, {
                    key: 1,
                    onBackEvent: _ctx.cancel,
                    pageError: _ctx.pageError
                  }, null, 8, ["onBackEvent", "pageError"]))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_TheFooter)
          ])
        ])
      ])
    ])
  ], 64))
}